import React, {useMemo} from "react"
import {Outlet, useMatches} from "@tanstack/react-router"
import MainMenu from "@/components/main-menu"
import SiteLogo from "@/components/site-logo"
import ActiveUser from "@/components/active-user"
import MobileToolbarWrapper from "@/components/mobile-toolbar"
import {PageDef} from "@/library/types/pages"
import PageHeader from "@/components/ui-kit/page-header"

export default function PortalLayout() {
    const matches = useMatches()

    const info: PageDef = useMemo(() =>
            Object.entries(matches.last().staticData).find(e => e[0] == "pageInfo")?.at(1) ?? {}
        , [matches])

    return <MobileToolbarWrapper>
        <PageHeader
            pageName={info.pageTitle ?? info.navName}
            pageDescription={info.description}
        />

        <div className="portal portal--header portal--sidebar">
            <aside>
                <SiteLogo/>
                <ActiveUser/>
                <MainMenu mode="vertical"/>
            </aside>
            <header style={{display: "none"}}>
            </header>
            <main className="justify-left">
                <Outlet/>
            </main>
        </div>
    </MobileToolbarWrapper>
}
